import { render, staticRenderFns } from "./PromotionPage.vue?vue&type=template&id=5b0e9434&"
import script from "./PromotionPage.vue?vue&type=script&lang=ts&"
export * from "./PromotionPage.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports